export class ConsumerTrackingServiceV2 {
    proxy;
    cancelRegisteredImpressions = new Set();
    savedFeatureAppName;
    featureAppId;
    constructor(proxy, defaultId) {
        this.proxy = proxy;
        this.featureAppId = defaultId;
    }
    get featureAppName() {
        return this.savedFeatureAppName;
    }
    set featureAppName(featureAppName) {
        this.savedFeatureAppName = featureAppName;
        this.proxy.setFeatureAppName({ id: this.featureAppId, name: this.featureAppName });
    }
    track(event) {
        this.proxy.track({ id: this.featureAppId, name: this.featureAppName }, event);
    }
    trackInternalNavigation(event, href) {
        this.proxy.trackInternalNavigation({ id: this.featureAppId, name: this.featureAppName }, event, href);
    }
    registerImpressionTracking(element, createDefaultImpressionEvent, furtherImpressions) {
        const unregister = this.proxy.registerImpressionTracking({ id: this.featureAppId, name: this.featureAppName }, element, createDefaultImpressionEvent, furtherImpressions);
        this.cancelRegisteredImpressions.add(unregister);
        return unregister;
    }
    updateComponent(componentUpdate) {
        this.proxy.updateComponent({ id: this.featureAppId, name: this.featureAppName }, componentUpdate);
    }
    updateUser(data) {
        this.proxy.updateUser(data);
    }
    evaluateLinkType(targetUrl) {
        return this.proxy.evaluateLinkType(targetUrl);
    }
    getDatalayer() {
        return this.proxy.getDatalayer();
    }
    sanitizeUrl(url) {
        return this.proxy.sanitizeUrl(url);
    }
    unbind() {
        this.cancelRegisteredImpressions.forEach((unregister) => unregister());
        this.cancelRegisteredImpressions.clear();
        this.proxy.removeComponent(this.featureAppId);
    }
}
